<script>
  import { run } from 'svelte/legacy';

    // -- IMPORTS
    import { onMount } from 'svelte';
    import PageHeading from '../component/header/PageHeading.svelte';
    import { fetchData, isObjectEmpty, websiteUrl } from '../base';
    import Seo from '../component/element/Seo.svelte';
    import { languageArrayStore } from '../store/languageArrayStore';
    import { getLocalizedText } from 'senselogic-gist';
    import { pageStore } from '../store/pageDataStore';
    import FullLoading from '../component/Layout/FullLoading.svelte';
    import urlStore from '../store/urlStore';
    import RenderBlockByType from '../component/element/renderBlockByType.svelte';

    // -- VARIABLES

    let isLoading = $state(true);
    let homePage = $state($pageStore.page.homePage);
    let homeBlockArray = $state($pageStore.block.homeBlockArray);
    let name = $state('');
    let metaTitle = $state('');
    let metaDescription = $state('');
    let metaKeywords = $state('');
    let imagePath = $state('');
    let url = $state('');

    // -- FUNCTIONS

    async function loadData(
        )
    {
        try
        {
            isLoading = true;



            let homeData =
                await fetchData(
                    '/api/page/get-home',
                    {
                        method: 'POST',
                        body: JSON.stringify(
                            {
                            }
                        ),
                        headers: { 'Content-Type': 'application/json' }
                    }
                    );

            let generalBlockArray = homeData.blockArray.sort(
                ( a, b ) =>
                {
                    if ( a.number !== b.number )
                    {
                        return a.number - b.number
                    }

                    return a.sectionPositionNumber - b.sectionPositionNumber
                }
            )

            homeBlockArray =
                generalBlockArray.filter(
                    ( block ) =>
                    {
                        return block.typeSlug !== 'disabled'
                    }
                );

            homePage = homeData.page;

            $pageStore.block.homeBlockArray = generalBlockArray;
            $pageStore.page = homeData.page;

            $pageStore.page.homePage = homeData.page;
            homePage = homeData.page;
            name = homeData.page.slug;
            metaTitle = homeData.page.title;
            metaDescription = homeData.page.subTitle;
            metaKeywords = homeData.page.metaKeywords;
            imagePath = homeData.page.imagePath;
            url = websiteUrl;
        }
        catch ( error )
        {
            console.error( 'Error:', error )
        }
        finally
        {
            isLoading = false;
        }
    }

    // -- STATEMENTS

    onMount(
        () =>
        {
            if (
                homePage === undefined
                || homeBlockArray === undefined
            )
            {
                loadData()
            }
            else
            {
                isLoading = false;
            }

            document.addEventListener( 'on-edit-block', loadData );

            return () => {
                window.removeEventListener( 'on-edit-block', loadData );
            }
        }
    );

    run(() => {
    if ( $urlStore.pathname === '/en' )
          {
              document.title = 'Home';
          }
  });
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../constant.styl';
    @import '../../mixin.styl';

    // -- CLASSES

    .home-image-container
    {
        height: 38.5rem;
        width: 100%;
    }

    :global( .home-image )
    {
        height: 100%;
        width: 100%;

        +media( smaller-32em )
        {
            background-position: center right 30% !important;
        }
    }

    .description-text
    {
        margin-bottom: 2rem;
        padding: 0rem 1.5rem 5rem 1.5rem;

        font-size: 1.5rem;

        +media( desktop )
        {
            max-width: 80vw;
        }
    }
</style>

<svelte:head>
    {#if !isObjectEmpty( name )}
        <title>{ getLocalizedText( name ).charAt( 0 ).toUpperCase() + name.slice( 1 ) }</title>
    {/if}
</svelte:head>

{#if isLoading}
    <FullLoading />
{:else}
    <Seo
        metaTitle={ metaTitle }
        metaDescription={ metaDescription }
        metaKeywords={ metaKeywords }
        url={ url }
        mediaPath={ imagePath }
        languageData={ $languageArrayStore }
        path=""
    />
    
    <PageHeading
        title={ homePage.title }
        subtitle={ homePage.description }
        mediaPath={ homePage.mediaPath ?? homePage.mediaPathArray }
    />

    {#await import( '$lib/component/element/AdminEditButton.svelte' ) then { default : AdminEditButton }}
        <AdminEditButton
            inset="10rem 5rem auto auto"
            type="home"
            title={ "Home" }
        />
    {/await}

    <RenderBlockByType
        pageId={ homePage.id }
        blockArray={ homeBlockArray }
    />
{/if}
